module.exports = function getResource(label, vars = []) {
    let resources = {
        myReservations: 'My Reservations',
        upcomingReservations: 'Upcoming Reservations',
        noReservationsLabel: 'You don’t have any reservations yet.',
        noReservationsButtonLabel: 'See what’s happening',
        noReservationsText: 'Check out Happening at Sephora to see what’s available near you. Beauty Insider members, take advantage of all the experiences Sephora has to offer—book your first service today!'
    };

    return resources[label];
};
